import mutations from './mutations';
import Cookies from 'js-cookie';
import { login, getMenu, } from '@/api/authentication'
import * as config from '@/utils/config.ts';
import { siteList } from '@/api/website'
import router from '@/routes/protectedRoute.js'
const state = () => ({
    login: !!Cookies.get('logedIn_c'),
    loading: false,
    error: null,
    menuData: [],
    website_menu_data: [],
    site_lang: '',
    token:'',
    super_login: false,
    collapsed: false,
    super_token: '',
    site_list: [],
    siteData: [],
    tabsList: [],//页签集合
    activeTab: null, // 当前激活的页签
    refreshFlags: {} // 键：路由path，值：刷新标记（时间戳）
});


const actions = {

    async login({ commit }, params) {
        try {
            localStorage.clear();
            commit('loginBegin');
            const rs = await login(params);

            if (!config.API_RES_CODE_SUC.includes(rs.code)) {
                commit('loginErr', '');
                return;
            }

            // 设置基础登录信息（与原始版本一致）
            Cookies.set('logedIn_c', true);
            Cookies.set('app_type', rs.data.app_type);
            Cookies.set('expires_time', rs.data.expires_time);
            Cookies.set('token', rs.data.token);
            Cookies.set('userinfo', JSON.stringify(rs.data.userinfo));
            commit('alearTabsList');
            const temp = {
                login: true,
                super_login: !!(params.order_id && params.super_token)
            };

            /* 兼容性修改：保留原始行为 */
            try {
                // 获取站点数据（最多重试2次）
                let siteData = null;
                let retryCount = 0;

                while (!siteData && retryCount < 2) {
                    try {
                        const siteResponse = await siteList();
                        siteData = siteResponse.data;
                    } catch (error) {
                        console.warn("站点数据获取失败，重试中...", error);
                        retryCount++;
                        await new Promise(resolve => setTimeout(resolve, 300 * retryCount));
                    }
                }

                if (siteData) {
                    commit('siteDataFnc', siteData);
                    Cookies.set('copyright', siteData.goomay.copyright);
                    commit('siteListFnc', siteData.company);
                    localStorage.setItem('siteData', JSON.stringify(siteData));
                } else {
                    console.error("站点数据获取失败，但继续登录流程");
                    // 保留原始行为：即使失败也继续
                }
            } catch (siteError) {
                console.error("站点数据处理异常:", siteError);
                // 不阻断主流程
            }

            // 关键：保持原始执行顺序
            commit('loginSuccess', temp);

        } catch (error) {
            console.error("登录流程失败:", error);
            commit('loginErr', error.message || '');
        }
    },
    async logOut({ commit }) {
        try {
            commit('logoutBegin');
            commit('logoutSuccess', null);
            localStorage.clear();
            sessionStorage.clear();
            document.cookie.split('; ').forEach(val => {
                const [name] = val.split('=')
                Cookies.remove(name)
            })

        } catch (err) {
            commit('logoutErr', err);
        }
    },

    async getMenu({ commit, dispatch }, params) {
        return getMenu(params)
            .then(rs => {

                if (config.API_RES_CODE_SUC.includes(rs.code)) {
                    let menu_data = rs.data;


                    menu_data.forEach(v => {
                        /*有children 但不展示 为 菜单 为按钮 把chidren 删除并复制
                            用于解决 显示子级页面 会先显示 父级页面  的问题*/
                        if (v.route_path != '' && v.children && v.children.length > 0) {
                            v.children.forEach(child_v => {
                                menu_data.push(child_v);
                            })

                            v.children = [];
                        }
                    })
                    const web_arr = [];

                    menu_data.forEach(vv => {

                        if (vv.pid == config.WEBSITE_MENU_PID && vv.menu_type == 1) web_arr.push(vv);
                    })

                    commit('menuData', menu_data);
                    // 修改记录

                    commit('websiteMenuData', web_arr);

                } else {
                    dispatch('logOut')
                }

            }).catch(() => {
                dispatch('logOut')
            })
    },
    setItemLang({ commit }, lang) {
        commit('someMutation', lang);
    },
    async addTabs({ commit }, view) {
        commit('ADD_TABS_LIST', view)
        commit('SET_TABS_LIST', view.name)
    },
    async delTabs({ commit, state }, view) {
        let tabsValue;
        const currentItem = state.tabsList.find(val => val.id === view.id) // 拿到当前删除的数据
        if (!currentItem) return; // 如果没找到当前项则退出
        const currentIndex = state.tabsList.indexOf(currentItem); // tabsList数组中当前项的索引
        const nextItem = state.tabsList[currentIndex + 1] //点击当前项的下一项数据，用于删除当前项后跳转到下一项、
        const prevItem = state.tabsList[currentIndex - 1] // 当前项的上一项数据（新增）
        if (state.activeTab == view.id) {
            if (state.tabsList.length > 0) {
                if (currentItem.id === state.tabsList[state.tabsList.length - 1].id) { // 当删除的是当前数据并且数据是最后一项
                    tabsValue = prevItem //拿到删除后的最后一项，
                } else {
                    tabsValue = nextItem;
                }
                commit('DEL_TABS_LIST', view)
                commit('SET_TABS_LIST', tabsValue.id)
                await router.push(tabsValue.path)
            }
        }else {
            commit('DEL_TABS_LIST', view)
        }

    }


};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
